import React from 'react';

const Loading = () => (
    <div className='text-center mt-3'>
        <i className='fas fa-sync fa-spin fa-10x'> </i>
    </div>
)

export default Loading